import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import Navbar from '../PartnerPage/Navbar';
const HeroSection = ({
  partnerConfig,
  generateCTAPath, 
  title, 
  subtitle, 
  backgroundImage, 
  backgroundPosition = '0 0',
  isBooking = false,
  customClass = '',
  children,
  logoURL
}) => {
  const backgroundImageStyles = {
    backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.4), rgba(0, 0, 0, 0.4)), url(${backgroundImage})`,
    backgroundPosition: backgroundPosition,
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat'
  };

  return (
    <>
      <section 
        className={`relative min-h-[80vh] flex flex-col justify-start items-center px-4 ${customClass}`}
        style={backgroundImageStyles}
      >
        <Navbar
          NavLogo={partnerConfig.images.navLogo}
          subdomain={partnerConfig.subdomain || undefined}
          logoClasses={partnerConfig.logoClasses}
          customCTAPath={generateCTAPath(partnerConfig.couponCode, partnerConfig.defaultCTAPath)}
          showExtraLinks={partnerConfig.showNavExtraLinks}
          defaultMenuItems={partnerConfig.defaultMenuItems}
          logoURL={partnerConfig.logoURL}
          shipNow={false}
          isBooking={isBooking}
        />
        
          <div className="w-full flex flex-col items-center">
            {!isBooking && (
              <div className="w-full text-center">
                <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 leading-tight mx-auto max-w-4xl pt-[20px]">
                  {parse(title)}
                </h1>
                <p className="text-lg md:text-xl text-white font-medium mb-8 mx-auto max-w-4xl">
                  {parse(subtitle)}
                </p>
              </div>
            )}
            {children && (
              <div className="w-full mx-auto flex justify-center">
                <div className="w-full">
                  {children}
                </div>
              </div>
            )}
        </div>

      </section>
      {!isBooking && (
        <div className="w-full h-[63px] bg-green-500 flex items-center justify-center">
          <span className="text-white p-2 text-xl md:text-3xl font-light text-center">
              Cruising was always meant to be <span className="font-semibold">this easy</span>.
          </span>
        </div>
      )}
    </>
  );
};

HeroSection.propTypes = {
  partnerConfig: PropTypes.object.isRequired,
  generateCTAPath: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string.isRequired,
  backgroundImage: PropTypes.string.isRequired,
  backgroundPosition: PropTypes.string,
  customClass: PropTypes.string,
  isBooking: PropTypes.bool,
  children: PropTypes.node,
  logoURL: PropTypes.string
};

export default HeroSection;